module.exports = __webpack_public_path__ + "static/media/submit-details.1dfcc162.png";